export const OVERLAY_CLASSNAME = ' z-50 border-none bg-black/50 backdrop-blur-sm';
